import React, { ReactElement } from 'react';
import { Col, Row } from 'antd';

interface FormRowProps {
  colSizes?: number[][]
  colSpans?: number[]
  gap?: number
}

export const FormRow: React.FC<FormRowProps> = (props) => {
  const columnSizes = props.colSizes;
  const columnSpan = props.colSpans;
  const children = React.Children.toArray(props.children) as ReactElement<any,React.FC<any>>[];
  const hasColComponent = children.every(child => child.type.displayName === 'Col');

  if (props.colSpans?.length > 0) {
    return renderFormRow(children, columnSpan, props.gap);
  }

  const columns = children.map((child, idx) => {
    const colSizes = columnSizes[idx];
    const spanSize = colSizes[0] + colSizes[1];
    let newChild = null;
    if (hasColComponent) {
      const subChildren = React.Children.toArray(child.props.children) as ReactElement[];
      newChild = subChildren.map((child) => cloneChild(child, colSizes));
    }
    else {
      newChild = cloneChild(child, colSizes);
    }
    
    return (
      <Col span={spanSize} key={idx}>
        {newChild}
      </Col>
    );
  });

  return (
    <Row>
      {columns}
    </Row>
  );
};

const renderFormRow = (children: React.ReactChild[], columnSpan: number [], gap = 32) => {
  const mx = gap / 2;
  const rowStyle = { marginLeft: -mx, marginRight: -mx, display: 'flex' };
  
  const columns = children.map((child, idx) => {
    const spanSize = columnSpan?.[idx] ?? (24 / children.length);
    const itemStyle = { paddingLeft: mx, paddingRight: mx, display: 'block', flex: 1 };
    const props = {class: `ant-col-${spanSize}`, style: itemStyle};
    return React.createElement('item', {'is': '', key: idx, ...props},
      child
    );
  });

  return (
    React.createElement('row', {'is': '', style: rowStyle}, columns)
  );
};

function cloneChild(child: React.ReactElement, colSizes: number[]) {
  const colProps = {
    labelCol: { flex: `${colSizes[0]} 1` },
    wrapperCol: { flex: `${colSizes[1]} 1` }
  };
  const newChild = React.cloneElement(child, colProps);
  return newChild;
}
